import type { SafetyStockRow } from '../../api/services/SafetyStockService';

export function safetyStockSelectionKey(
  row: Pick<SafetyStockRow, 'productId' | 'locationId'>,
): string {
  return `${row.productId}-${row.locationId}`;
}
